import React from 'react'

import * as style from './HuntEmbeded.module.css'

export default function HuntEmbeded() {
  return (
    <div className={style.root}>
      <a
        href="https://www.producthunt.com/posts/ocean-templates?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-ocean&#0045;templates"
        target="_blank"
        rel="noreferrer"
      >
        <img
          src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=401600&theme=light"
          alt="Ocean&#0032;Templates - Open&#0045;source&#0032;toolkit&#0032;to&#0032;build&#0032;full&#0045;stack&#0032;decentralised&#0032;dApps | Product Hunt"
          style={{ width: '170px', height: '40px' }}
          width="170"
          height="40"
        />
      </a>
    </div>
  )
}
